import { IncomingMessage, ServerResponse } from 'http';
import cookie from 'react-cookies';
import cookieParser from 'cookie';
import { isServerSide } from '~/src/helpers/ssr';

interface IServResponseWithCookie extends ServerResponse {
    cookie: (a: string, b: string | number, c: Record<string, unknown>) => void;
}
interface ISetCookie {
    cookieName: string,
    cookieValue: string,
    cookieConfig: Record<string, unknown>,
    res?: ServerResponse,
}

// Устанавливает cookie на сервере или на клиенте (res - требуется для сервера, maxAge - задавать в секундах.)
export const setCookie = ({ cookieName, cookieValue, cookieConfig, res }: ISetCookie): void => {
    const resWithCookie = res as IServResponseWithCookie;
    const { maxAge } = cookieConfig;
    const config = { ...cookieConfig };

    if (maxAge) {
        config.maxAge = Number(maxAge) * 1000; // maxAge - в миллисекундах, для установки с сервера
    }

    if (isServerSide()) {
        resWithCookie?.cookie(cookieName, cookieValue, config);
    } else {
        cookie.save(cookieName, cookieValue, cookieConfig);
    }
};

// Получает cookie на сервере или на клиенте (req - требуется для сервера)
export const getCookie = (cookieName: string, req?: IncomingMessage): string | undefined => {
    if (isServerSide()) {
        if (!req || !req.headers || !req.headers.cookie) {
            return undefined;
        }
        const parsedCookie = cookieParser.parse(req.headers.cookie);

        return parsedCookie[cookieName];
    } else {
        const loadCookie = cookie.load(cookieName, true);

        return loadCookie || undefined;
    }
};

export const getCookieFromResponse = (cookieName?: string, res?: ServerResponse): string | undefined => {
    if (!cookieName || !res) {
        return undefined;
    }

    let cookies = res.getHeader('Set-Cookie') || [];

    if (typeof cookies === 'string') {
        cookies = [cookies];
    }

    if (typeof cookies === 'number') {
        cookies = [];
    }
    const cookieStr = cookies.find(el => el.includes(`${cookieName}=`));

    const nameStr = cookieStr?.split(';').find(el => el.includes(`${cookieName}=`))?.trim();
    const [, value] = nameStr ? nameStr.split('=') : [];

    return value;
};
